import network from "@/api/network";

export default class Prize {
  static async getPrizeList() {
    return await network.get("prize/list", null, {});
  }

  static async checkPrizeForPD(data) {
    return await network.get('prize/pd/check', data, {});
  }

  static async orderPrize(data) {
    return await network.post("prize/exchange", data, {});
  }

  static async getCharacteristics() {
    return await network.get("prize/characteristics/list", null, {});
  }

  static async uploadPersonalData(data) {
    return await network.post("user/profile/add/documents", data, {});
  }

  static async getPOSList() {
    return await network.get("pos-materials/list", null, {});
  }
}
